<div class="container-fluid p-0">
  <div class="bb-light bg-grey pt-3 px-4 px-md-5" *ngIf="cityStateText">
    <div class="d-flex mb-3">
      <a class="mr-2 underline" [routerLink]="['/']">Home</a>
      <span class="mr-2">></span>
      <ng-container *ngIf="primaryType && primaryType != 'all'">
        <a class="underline" [routerLink]="['/equipment-rentals', 'all', cityStateForSearch]">All Rentals</a>
        <span class="ml-2">></span>
      </ng-container>
      <ng-container *ngIf="make">
        <a class="ml-2 underline" [routerLink]="['/equipment-rentals', primaryType, cityStateForSearch]">{{ primaryType | titlecase }}</a>
        <span class="ml-2">></span>
      </ng-container>
    </div>
    <div class="mb-3">
      <h1 class="search-header" *ngIf="!primaryType || primaryType == 'all'; else hasPrimaryType">Construction Equipment rentals {{ cityStateText }}</h1>
      <ng-template #hasPrimaryType>
        <h1 class="search-header">{{ make ? make + " " : "" }}{{ primaryType | titlecase }}{{ showS }} rentals {{ cityStateText }}</h1>
      </ng-template>
    </div>
    <app-v2-topbar-search-results-search class="d-lg-none" [primaryType]="primaryType"></app-v2-topbar-search-results-search>
  </div>
  <!-- <app-topbar-search-results-search class="d-lg-none"></app-topbar-search-results-search> -->

  <div class="row">
    <div class="col-lg-3 col-xxxl-2 d-none d-lg-block">
      <app-router-sidebar-search-results></app-router-sidebar-search-results>
    </div>
    <div class="col-lg-9 col-xxxl-10 px-0 box-shadow-left">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
